module.exports = __webpack_public_path__ + "img/hair_front_female_frizzy_middle_part.f0e2760c.png";